import VeeValidate from 'vee-validate'
import Vue from 'vue'

const dictionary = {
    messages: {
        min:      () => 'VALIDATION.MIN_LENGTH',
        email:    () => 'VALIDATION.EMAIL_REQUIRED',
        password: () => 'VALIDATION.PASSWORD_REQUIRED',
        required: () => 'Error',
        regex:    () => 'VALIDATION.INVALID_FORMAT'
    }
}
  
const Vee = {
    install (Vue) {
      Vue.use(VeeValidate)
      VeeValidate.Validator.localize('en', dictionary)
    }
  }
  
export default Vee


// WEBPACK FOOTER //
// ./src/plugins/vee.js